import React from 'react';
import { ReactComponent } from 'Common/components/Icons/person-add.svg';

const PersonAdd = () => <ReactComponent className="MuiSvgIcon-root" />;

export default PersonAdd;
